import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants/style';

export const useStyles = makeStyles(() =>
  createStyles({
    contextMenu: {
      '& .MuiPaper-root': {
        boxShadow: 'none',
        border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
        borderRadius: '12px',
        minWidth: '174px',
        marginTop: '12px',
        padding: '0px 12px',
      },
    },
    accountButton: {
      height: '52px' + '!important',
      padding: '14px 24px' + '!important',
      border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
      borderRadius: '52px' + '!important',
      fontSize: '16px' + '!important',
      fontWeight: 400 + '!important',
      lineHeight: '24px' + '!important',
      color: STYLE.COLOR.TEXT1 + '!important',
      textTransform: 'none',
      flexShrink: 0,
      whiteSpace: 'nowrap',
      backgroundColor: STYLE.COLOR.WHITE + '!important',
      '& .MuiButton-endIcon': {
        marginLeft: '8px',
        marginRight: 0,
      },
    },
    arrowIcon: {
      height: '24px',
      width: '24px',
      transition: 'all 0.2s ease-in',
    },
    arrowIconRotated: {
      height: '24px',
      width: '24px',
      transform: 'rotate(180deg)',
      transition: 'all 0.2s ease-in',
    },
    menuItem: {
      padding: '8px 8px 8px 6px' + '!important',
      fontSize: '14px' + '!important',
      fontWeight: 400,
      lineHeight: '20px' + '!important',
      color: STYLE.COLOR.TEXT1 + '!important',
      '&:hover, &.Mui-selected': {
        backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
        borderRadius: '8px !important',
      },
    },
  }),
);
